import { FaIcon } from '@/lib/fa'
import { faClose } from '@fortawesome/pro-light-svg-icons'
import React from 'react'

const DayScheduleHeader = ({close}) => {
  return (
    <div className="tw-ring-b tw-ring-base-100">
      <div className={`tw-flex tw-flex-col tw-gap-6 tw-py-4 tw-pb-0`}>
        <div className="tw-flex tw-items-center tw-justify-between tw-px-4">
          <div className="tw-flex tw-items-center tw-gap-2">
            <p className="tw-gap-2 tw-text-xl tw-font-semibold tw-text-content-base">
              Zmień wartości
            </p>
          </div>
          <FaIcon
            icon={faClose}
            className="tw-h-5 tw-w-5 tw-cursor-pointer"
            onClick={() => close()}
          />
        </div>
      </div>
    </div>
  )
}

export default DayScheduleHeader
